import { createContext, useContext } from "react";
import {
  DEFAULT_COMPARISON_MODE,
  DEFAULT_CURRENCY,
  useTenantSettings,
} from "@acto/taskpane/core/data-access/tenant-settings/useTenantSettings";
import { KpiComparisonMode } from "@acto/taskpane/core/domain";
import { CurrencyCode } from "@acto/taskpane/core/utils/currencyCode";

const CurrencyContext = createContext<CurrencyCode>(DEFAULT_CURRENCY);
const ComparisonModeContext = createContext<KpiComparisonMode>(DEFAULT_COMPARISON_MODE);

export const useCurrencyContext = (): CurrencyCode => useContext(CurrencyContext);
export const useComparisonModeContext = (): KpiComparisonMode => useContext(ComparisonModeContext);
export const ComparisonModeProvider = ComparisonModeContext.Provider;

/**
 * Rendering children against the defaults before the query settles would show euro amounts and
 * year-over-year deltas, then swap both for the tenant's real settings, which reads as the
 * figures changing rather than as loading.
 */
export const TenantSettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const { currency, comparisonMode, resolved } = useTenantSettings();

  if (!resolved) {
    return null;
  }

  return (
    <CurrencyContext.Provider value={currency}>
      <ComparisonModeContext.Provider value={comparisonMode}>{children}</ComparisonModeContext.Provider>
    </CurrencyContext.Provider>
  );
};
